import { render, staticRenderFns } from "./billImportacion.vue?vue&type=template&id=ac974626&scoped=true&"
import script from "./billImportacion.vue?vue&type=script&lang=js&"
export * from "./billImportacion.vue?vue&type=script&lang=js&"
import style0 from "./billImportacion.vue?vue&type=style&index=0&id=ac974626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac974626",
  null
  
)

export default component.exports